import { render, staticRenderFns } from "./EducationalCategoryInfo.vue?vue&type=template&id=d2182a60&"
import script from "./EducationalCategoryInfo.vue?vue&type=script&lang=js&"
export * from "./EducationalCategoryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports